module.exports = __webpack_public_path__ + "static/media/qrcode.d396d11c.png";